import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';

export default data => {
  const dataCreate = parseToMutationRequest(data, [
    'amount',
    'amountRecognized',
    'billed',
    'salesChannel',
    'marketSegment',
    'accountType',
    'accountSubType',
    'revenueType',
    'revenueRecognitionType',
    'revenueActivityType',
    'transactionType',
    'status',
  ]);
  const recognizeManualRevenue = `recognizeManualRevenue(input: ${dataCreate})`;
  return gql`
  mutation {
    ${recognizeManualRevenue} {
      id
    }
  }
`;
};
